module.exports = __webpack_public_path__ + "static/media/no-recognition-post.0485902c.svg";